import SVG from './image.svg';

export default {
  SVG,
  name: 'r2',
};
